import { createReducer, on } from '@ngrx/store';
import * as GeneralAction from './general.actions';
import { GeneralJansenFilterEntity } from './general.models';

export const GENERAL_FEATURE_KEY = 'global';

export interface GeneralState {
  language: string | null;
  GPTiframe: boolean;
  jansenFilter: GeneralJansenFilterEntity;
  isDownloadDocumentActive: boolean;
  downloadDocumentFilename: string;
  downloadDocumentId: number | null;
}

export const initialGeneralState: GeneralState = {
  language: 'de',
  GPTiframe: false,
  jansenFilter: { language: 'de', categoryId: null },
  isDownloadDocumentActive: false,
  downloadDocumentFilename: '',
  downloadDocumentId: null,
};

export const generalReducer = createReducer(
  initialGeneralState,
  on(GeneralAction.setLanguage, (state, { language }) => ({
    ...state,
    language: language,
  })),
  on(GeneralAction.setGPTiframe, (state, { GPTiframe }) => ({
    ...state,
    GPTiframe: GPTiframe,
  })),
  on(GeneralAction.setJansenFilter, (state, { language, categoryId, searchTerm }) => ({
    ...state,
    jansenFilter: { language, categoryId, searchTerm },
  })),
  on(GeneralAction.downloadDocumentStart, (state) => ({
    ...state,
    isDownloadDocumentActive: true,
  })),
  on(GeneralAction.downloadDocumentEnd, (state) => ({
    ...state,
    isDownloadDocumentActive: false,
    downloadDocumentFilename: '',
    downloadDocumentId: null,
  })),
  on(GeneralAction.setDownloadDocumentFilename, (state, { filename }) => ({
    ...state,
    downloadDocumentFilename: filename,
  })),
  on(GeneralAction.setDownloadDocumentId, (state, { documentId }) => ({
    ...state,
    downloadDocumentId: documentId,
  }))
);
